import React from 'react';
import { Spinner } from 'react-bootstrap';
import { LuArrowRight } from 'react-icons/lu';
import { IntegratedOrdersCardProps } from '../types';

const IntegratedOrdersCard: React.FC<IntegratedOrdersCardProps> = ({
  integratedOrdersBreakdown,
  statsLoading,
  deliveryPercentage,
  onViewAll,
}) => {
  return (
    <div className="bg-white rounded-4 border border-1 border-light-subtle p-4 shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <span className="text-secondary small fw-semibold text-uppercase">
          Total {integratedOrdersBreakdown.total} Integrated orders
        </span>
        <button
          type="button"
          className="btn btn-link p-0 text-decoration-none text-primary small d-flex align-items-center gap-1"
          onClick={onViewAll}
        >
          View all <LuArrowRight size={13} />
        </button>
      </div>
      <div className="d-flex align-items-center gap-4 py-2">
        {/* Circular Donut Progress */}
        <div
          className="position-relative flex-shrink-0"
          style={{ width: 84, height: 84 }}
        >
          <svg width="84" height="84" viewBox="0 0 84 84">
            <circle
              cx="42"
              cy="42"
              r="34"
              stroke="#E2E8F0"
              strokeWidth="8"
              fill="none"
            />
            <circle
              cx="42"
              cy="42"
              r="34"
              stroke="#0284C7"
              strokeWidth="8"
              fill="none"
              strokeDasharray="213.6"
              strokeDashoffset={213.6 * (1 - deliveryPercentage / 100)}
              strokeLinecap="round"
              transform="rotate(-90 42 42)"
              style={{ transition: 'stroke-dashoffset 0.5s ease' }}
            />
          </svg>
          <div className="position-absolute top-50 start-50 translate-middle fw-bold text-dark fs-6">
            {deliveryPercentage}%
          </div>
        </div>

        {/* Descriptions */}
        <div className="min-w-0">
          <div className="fs-4 fw-bold text-dark mb-1">
            {statsLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              (integratedOrdersBreakdown?.synced ?? 0)
            )}
            <span className="fs-6 fw-normal text-secondary ms-2">
              Orders Synced
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(IntegratedOrdersCard);
